import { render } from "./MinOrderPriceAlertComponent.vue?vue&type=template&id=5f5e894e"
import script from "./MinOrderPriceAlertComponent.vue?vue&type=script&lang=js"
export * from "./MinOrderPriceAlertComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__